module.exports = __webpack_public_path__ + "img/cateicon2.57a96336.svg";